import { Tabs, TabsProps } from "antd";
import NoticeView from "./NoticeView";
import AcceleratorManagement from "./Accelerator/AcceleratorManagement";
import Dashboard from "./Manage/Dashboard";
import SentAccelerators from "./Accelerator/SentAccelerators";
import NoticePriceView from "./NoticePriceView";

const NoticeTabs = () => {
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "مرتبط با من",
      children: <Dashboard />,
    },
    {
      key: "2",
      label: "قیمت های دریافتی  ",
      children: <NoticePriceView tabNumber={2} />,
    },
    {
      key: "3",
      label: "شتاب های ارسالی",
      children: <SentAccelerators />,
    },
  ];
  const onChange = (key: string) => {
    //navigate(`/CompanyInfo?tab=${key}`);
  };

  return (
    <>
      <Tabs
        style={{ fontFamily: "YekanBakhVF", position: "fixed", width: "100%" }}
        tabBarStyle={{ marginBottom: 1 }} // Reduces spacing below tab headers
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
      />
    </>
  );
};
export default NoticeTabs;
